<template>
  <div v-if="copyright" class="text-center">
    <!-- eslint-disable vue/no-v-html -->
    <p class="small" v-html="copyright"></p>
    <!-- eslint-enable -->
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { GET_COPYRIGHT } from '#shared/types/getters';

const navFooter = useNavFooter();
const copyright = computed(() => navFooter?.[GET_COPYRIGHT]);
</script>

<style lang="scss" scoped brand="mcom">
p,
:deep(a) {
  color: $white;
}
</style>

<style lang="scss" scoped brand="bcom">
@import '~/assets/scss/mixins';

:deep(a) {
  @include body-menu-link-behavior;
}
</style>
